
import { useI18n } from 'vue-i18n';
import {
  defineComponent,
  ref,
  watch,
} from 'vue';
import Textarea from 'primevue/textarea';
import { isValidEmail } from '@/helpers/Email';
import { useToast } from 'primevue/usetoast';
import SpmButton from '@/components/spm-primevue/SpmButton.vue';
import ColumnMappings from '@/views/mes-listes/customers/ImportCustomers/ColumnMappings.vue';
import { store } from '@/store';
import { ManualListImportConfigData } from '@/types/lists';
import Tooltip from 'primevue/tooltip';

export default defineComponent({
  name: 'ConfigManualCopyPaste',

  components: {
    ColumnMappings,
    Textarea,
    SpmButton,
  },

  directives: {
    tooltip: Tooltip,
  },

  setup() {
    const { t } = useI18n();
    const toast = useToast();
    const showMappings = ref(false);
    const emailsStr = ref((store.getters['listImportEditor/getConfigData'] as ManualListImportConfigData).dataString);

    watch(() => emailsStr.value, () => {
      store.commit('listImportEditor/setConfigData', {
        ...store.getters['listImportEditor/getConfigData'],
        dataString: emailsStr.value,
      });
    });

    const validateCopyPasteInput = () => {
      const lines = emailsStr.value.trim().split('\n')
        .map((line) => line.trim())
        .filter((line) => line !== '');

      // Lignes sans aucune adresse e-mail valide (les champs sont séparés par des virgules)
      const invalidLines = lines.filter((line) => {
        const fields = line.split(',').map((field) => field.trim());
        return fields.filter((field) => isValidEmail(field)).length === 0;
      });

      if (invalidLines.length > 0) {
        // On ne cite que les premières lignes fautives pour garder un message lisible
        const maxShownLines = 5;
        const shownLines = invalidLines.slice(0, maxShownLines).join(', ')
          + (invalidLines.length > maxShownLines ? ', …' : '');

        toast.add({
          severity: 'error',
          summary: t('error'),
          detail: t('myLists.importContacts.errors.invalidLines', { count: invalidLines.length, lines: shownLines }),
          life: 6000,
        });
        return;
      }

      showMappings.value = true;
    };

    return {
      t,
      showMappings,
      emailsStr,
      validateCopyPasteInput,
    };
  },
});
